// The manuals offline pack (REPORT-manuals-2.md part 5): the manuals needed in an emergency at sea, kept on this device for THIS
// login, so they open with no internet:
//   - the manuals linked to a Contingency Plan (manual_links kind 'checklist' -> a checklist of category "Contingency Plans")
//   - the SMS manuals' emergency sections (generated manuals: the sections whose heading is about an emergency; an uploaded SMS
//     manual whose title is about emergencies: its file)
//   - the LSA / FFE manuals (category, title, or linked to LSA / FFE equipment)
// Only the CURRENT approved version (manuals.file_url mirrors it), not archived, and only what the login may see (the database
// rules decide what the queries return). Files go in Cache Storage under /__hc_manual/<user id>/..., removed when they leave the
// pack, when a newer version is approved, at sign-out, and when the login's rights change.
import { supabase } from './supabase'
import { CACHE, keyOf, indexKey, mediaKey, wipeUser, buildPack } from './manualOfflinePack'
import { signedManualUrl, setOfflineCopy } from './manualFiles'
import { signUrl } from './fileAccess'

const hasCaches = () => typeof caches !== 'undefined'
let me = null   // the login whose pack is used now

export async function readPack(uid = me) {
  if (!uid || !hasCaches()) return null
  try { const r = await (await caches.open(CACHE)).match(indexKey(uid)); return r ? await r.json() : null } catch (e) { return null }
}
// the offline copy of a manual's current file -> a blob: link (null when not in the pack)
export async function offlineFileUrl(manualId, uid = me) {
  if (!uid || !manualId || !hasCaches()) return null
  const pack = await readPack(uid)
  const it = pack && (pack.items || []).find(x => x.id === manualId && x.cached)
  if (!it) return null
  const r = await (await caches.open(CACHE)).match(keyOf(uid, it.id, it.version))
  return r ? URL.createObjectURL(await r.blob()) : null
}
setOfflineCopy(id => offlineFileUrl(id))
// an approved SOP's photo from the pack (sop-visual) -> a blob: link, null when it is not there
export async function offlineMediaUrl(path, uid = me) {
  if (!uid || !path || !hasCaches()) return null
  try { const r = await (await caches.open(CACHE)).match(mediaKey(uid, path)); return r ? URL.createObjectURL(await r.blob()) : null } catch (e) { return null }
}
// an approved SOP kept in the pack (its structured text) - Do it / Read work from it with no connection
export async function offlineSop(manualId, uid = me) {
  const pack = await readPack(uid)
  const it = pack && (pack.items || []).find(x => x.id === manualId && x.sop)
  return it ? it.sop : null
}

export async function wipeOfflinePack(uid) {
  if (!uid || !hasCaches()) return
  try { await wipeUser(await caches.open(CACHE), uid) } catch (e) {}
  if (me === uid) me = null
}

// build / refresh this login's pack in the background (useAuth after login, "Update now" on the Manuals page)
const running = new Map()   // uid|vessel -> the build in progress (the login and the Manuals page may ask at the same time)
export function refreshOfflinePack(args) {
  const k = args.uid + '|' + args.clientId
  if (!running.has(k)) running.set(k, refreshNow(args).finally(() => running.delete(k)))
  return running.get(k)
}
async function refreshNow({ uid, clientId, rightsHash = '', force = false }) {
  me = uid || me
  if (!hasCaches()) return { skipped: 'no storage' }
  return buildPack({ uid, clientId, rightsHash, force, db: supabase, cache: await caches.open(CACHE), online: typeof navigator === 'undefined' || navigator.onLine !== false,
    fetchMedia: async path => { const s = await signUrl(path); if (!s) return null; const r = await fetch(s); return r.ok ? r : null },
    fetchFile: async url => { const s = await signedManualUrl(url); if (!s) return null; const r = await fetch(s); return r.ok ? r : null } })
}
